import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { notify } from "../actions/CommonActions";
import { updateMemberApi } from "../../services";

const MEMBER_SECTIONS = [
  {
    title: "Member details",
    fields: [
      { name: "name", label: "Name", type: "text" },
      { name: "insuredNumber", label: "Insured number", type: "text" },
      { name: "dob", label: "Date of birth", type: "date" },
      { name: "gender", label: "Gender", type: "gender" },
    ],
  },
  {
    title: "Contact",
    fields: [
      { name: "phoneNumber", label: "Phone number", type: "text" },
      { name: "email", label: "Email", type: "email" },
      { name: "address", label: "Address", type: "text", wide: true },
    ],
  },
  {
    title: "Identification",
    fields: [
      { name: "identificationDoc", label: "Identification document", type: "doc" },
      { name: "identificationNumber", label: "Identification number", type: "text" },
      { name: "employmentStatus", label: "Employment status", type: "text" },
    ],
  },
];

const IDENTIFICATION_DOCS = [
  "Staff ID",
  "National ID",
  "Passport",
  "Driver's License",
];

export const UpdateMemberModal = ({
  showUser,
  toggleShowUser,
  selectedMember,
  refetch,
}) => {
  const [updateMember, setUpdateMember] = useState({
    name: "",
    address: "",
    insuredNumber: "",
    dob: "",
    gender: "",
    identificationDoc: "",
    identificationNumber: "",
    phoneNumber: "",
    email: "",
    employmentStatus: "",
    policyNumber: "",
  });
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (selectedMember) {
      setUpdateMember({
        name: selectedMember.name || "",
        address: selectedMember.address || "",
        insuredNumber: selectedMember.insuredNumber
          ? String(selectedMember.insuredNumber)
          : "",
        dob: selectedMember.dob
          ? new Date(selectedMember.dob).toISOString().substring(0, 10)
          : "",
        gender: selectedMember.gender || "",
        identificationDoc: selectedMember.identificationDoc || "",
        identificationNumber: selectedMember.identificationNumber || "",
        phoneNumber: selectedMember.phoneNumber || "",
        email: selectedMember.email || "",
        employmentStatus: selectedMember.employmentStatus || "",
        policyNumber: selectedMember.policyNumber || "",
      });
    }
  }, [selectedMember]);

  const handleUpdateChange = (e) => {
    const { name, value } = e.target;
    setUpdateMember((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateCall = () => {
    setIsUpdating(true);
    const payload = {
      ...updateMember,
      insuredNumber: updateMember.insuredNumber
        ? Number(updateMember.insuredNumber)
        : undefined,
    };

    updateMemberApi(selectedMember?.id, payload)
      .then((res) => {
        notify(
          "success",
          "Success",
          res?.message || "Member updated successfully"
        );
        setIsUpdating(false);
        toggleShowUser();
        refetch();
      })
      .catch((error) => {
        notify(
          "danger",
          "OOPS",
          error?.response?.data?.message || "Failed to update member"
        );
        setIsUpdating(false);
      });
  };

  const renderField = (field) => {
    if (field.type === "gender") {
      return (
        <Form.Select
          name={field.name}
          value={updateMember[field.name]}
          onChange={handleUpdateChange}
        >
          <option value="">Select gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </Form.Select>
      );
    }

    if (field.type === "doc") {
      return (
        <Form.Select
          name={field.name}
          value={updateMember[field.name]}
          onChange={handleUpdateChange}
        >
          <option value="">Select doc type</option>
          {IDENTIFICATION_DOCS.map((doc) => (
            <option value={doc} key={doc}>
              {doc}
            </option>
          ))}
        </Form.Select>
      );
    }

    return (
      <Form.Control
        name={field.name}
        type={field.type}
        value={updateMember[field.name]}
        onChange={handleUpdateChange}
      />
    );
  };

  return (
    <Modal
      show={showUser}
      onHide={toggleShowUser}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Update member details</Modal.Title>
          <div className="surface-card__meta">
            {selectedMember?.policyNumber
              ? `Member of policy ${selectedMember?.policyNumber}`
              : "Edit the member record"}
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="modal-body--scroll">
        {MEMBER_SECTIONS.map((section) => (
          <div className="form-section" key={section.title}>
            <div className="form-section__title">{section.title}</div>
            <div className="form-grid">
              {section.fields.map((field) => (
                <div
                  key={field.name}
                  style={field.wide ? { gridColumn: "1 / -1" } : undefined}
                >
                  <Form.Group>
                    <Form.Label>{field.label}</Form.Label>
                    {renderField(field)}
                  </Form.Group>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={toggleShowUser}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={(e) => {
            e.preventDefault();
            handleUpdateCall();
          }}
          disabled={isUpdating}
        >
          {isUpdating ? "Updating..." : "Update member"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
